var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24697 12.2422C7.09636 12.1587 6.9134 12.1587 6.76271 12.242L3.57964 14.0018C3.21435 14.2037 2.77704 13.8956 2.84424 13.4837L3.46424 9.68308C3.48981 9.52633 3.4394 9.36677 3.32842 9.25317L0.680865 6.5432C0.396302 6.25193 0.560628 5.76085 0.963184 5.6995L4.57288 5.14939C4.73779 5.12426 4.87931 5.01854 4.95018 4.86753L6.54737 1.46441C6.72732 1.08099 7.27268 1.08099 7.45263 1.46441L9.04982 4.86753C9.12069 5.01854 9.26221 5.12426 9.42712 5.14939L13.0368 5.6995C13.4394 5.76085 13.6037 6.25193 13.3191 6.5432L10.6716 9.25317C10.5606 9.36677 10.5102 9.52633 10.5358 9.68308L11.1556 13.4824C11.2228 13.8946 10.785 14.2027 10.4197 14.0003L7.24697 12.2422Z",
    fill: "#354D9E",
    stroke: "#354D9E",
    strokeWidth: 0.734043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating-star.b27be9ddc70529e638b7424211173c72.svg";
export { ForwardRef as ReactComponent };